import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Heart, Github } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-responsive py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <Leaf className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">PKU Tracker</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              A comprehensive food tracking application for PKU patients in the UK, helping manage diet and nutrition with ease.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com/your-username/pku-tracker"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-300 hover:text-white transition-colors">
                  Search Foods
                </Link>
              </li>
              <li>
                <Link to="/free-foods" className="text-gray-300 hover:text-white transition-colors">
                  Free Foods
                </Link>
              </li>
              <li>
                <Link to="/add-food" className="text-gray-300 hover:text-white transition-colors">
                  Add Food
                </Link>
              </li>
            </ul>
          </div>

          {/* UK Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">UK Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About PKU
                </Link>
              </li>
              <li>
                <a
                  href="https://www.nspku.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  NSPKU
                </a>
              </li>
              <li>
                <a
                  href="https://www.nhs.uk/conditions/phenylketonuria/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  NHS PKU Info
                </a>
              </li>
              <li>
                <a
                  href="https://www.gov.uk/government/publications/food-standards-agency-food-additives"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  FSA Food Additives
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} PKU Tracker. Made with{' '}
              <Heart className="inline w-4 h-4 text-red-500" /> for the UK PKU community.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
